import { SCORECARD_PANEL_SECTION_LABEL } from "../../constants";

import { cn } from "@/lib/utils";

interface ScorecardSectionHeaderProps {
  label: string;
  action?: React.ReactNode;
  className?: string;
}

const ScorecardSectionHeader = ({ label, action, className }: ScorecardSectionHeaderProps) => (
  <div className={cn("flex items-center justify-between gap-2", className)}>
    <span className={cn(SCORECARD_PANEL_SECTION_LABEL, "min-w-0 truncate")}>{label}</span>
    {action ? <div className="shrink-0">{action}</div> : null}
  </div>
);

export default ScorecardSectionHeader;
